import { PropsWithChildren } from "react";
import { useEntityContext } from "./useEntityContext";
import { Empty, Pagination, theme } from "antd";
import {
  entityTimeMachineContext,
  useEntityTimeMachine,
  useEntityTimeMachineContext,
} from "./useEntityTimeMachine";
import { TimeMachineCard } from "./components/TimeMachineCard";
import { LoadingOutlined } from "@ant-design/icons";
import { Flex } from "src/components/Flex";
import { useOrg } from "src/hooks/useOrg";

export const TimeMachine = ({ children }: PropsWithChildren) => {
  useEntityTimeMachine;
  const { query } = useEntityContext();
  const orgId = useOrg().id!;
  const entityTimeMachine = useEntityTimeMachine({
    orgId,
    entityUuid: query.data.entity.properties.uuid,
    type: query.data.entity.labels[0],
  });
  return (
    <entityTimeMachineContext.Provider value={entityTimeMachine}>
      {children}
    </entityTimeMachineContext.Provider>
  );
};

export const TimeMachineComponent = () => {
  const { token } = theme.useToken();
  const { query, setPagination } = useEntityTimeMachineContext();
  return (
    <div>
      {query.isLoading && (
        <Flex centered style={{ padding: 16 }}>
          <LoadingOutlined />
        </Flex>
      )}
      {query.data?.data.length === 0 && <Empty />}
      {query.data?.data.map((item: any, index: number) => {
        return <TimeMachineCard key={index} event={item} />;
      })}
      {query.data && (
        <Pagination
          size="small"
          hideOnSinglePage={true}
          current={query.data?.meta.page}
          total={query.data?.meta.total}
          pageSize={query.data?.meta.pageSize}
          showSizeChanger={false}
          showTotal={(t, [r1, r2]) =>
            (r1 > 1 || r2 < t) && (
              <div style={{ fontSize: 12, color: token.colorTextSecondary }}>
                showing {r1}-{r2} of {t}
              </div>
            )
          }
          onChange={(page, pageSize) => {
            setPagination({ page, pageSize });
          }}
          style={{ textAlign: "right", marginTop: 10 }}
        />
      )}
    </div>
  );
};
